<div class="dropDown">
    <div class="dropdown-item" (click)="openDialog(data.currentUser, data.currentUser.id)">
        <img class="desktop-hidden" src="../../../../assets/img/icons/account_circle_bk.png" alt="">
        <span >Profil</span>
    </div>
    <div class="dropdown-item" (click)="logOut()">
        <img class="desktop-hidden" src="../../../../assets/img/icons/logout.png" alt="">
        <span >Log out</span>
    </div>
</div>